import { postcodeValidator } from 'postcode-validator';

/**
 * Validates a zipcode/postal code based on the country.
 * Uses postcode-validator for robust validation across most countries.
 *
 * @param zipcode - The zip code string to validate.
 * @param countryCode - The ISO 3166-1 alpha-2 country code (e.g., 'US', 'GB', 'LT').
 * @returns boolean - True if the zipcode is valid for the specified country.
 */
export const validateZipcode = (
  zipcode: string,
  countryCode: string,
): boolean => {
  if (!countryCode || !zipcode) return false;

  const normalizedCountry = countryCode.trim().toUpperCase();
  const cleanedZip = zipcode.trim();

  return postcodeValidator(cleanedZip, normalizedCountry);
};
